import styled from 'styled-components'
import { type ShoppingCategory } from '@/features/shop/services/ShoppingCategories/types'
import { MoreCategoryItem } from '@/features/shop/components/CategorySubNav/MoreCategoryItem'
import { type OnCategorySelect } from '@/features/shop/components/CategorySubNav/types'
import { Stack } from '@shipt/design-system-layouts'
import { Body } from '@shipt/design-system-typography'
import { useMediaQuery } from '@/features/shared/hooks/useMediaQuery'

interface Props {
  onCategorySelect: OnCategorySelect
  moreCategories: ShoppingCategory[]
  featuredCategories: ShoppingCategory[]
  drawerIsVisible: boolean
}

export const MoreCategories = ({
  onCategorySelect,
  moreCategories,
  featuredCategories,
  drawerIsVisible,
}: Props) => {
  const { screenLg } = useMediaQuery()

  const hasFeaturedCategories = featuredCategories.length > 0

  return (
    <Stack direction={screenLg ? 'row' : 'column'} spacing="sm">
      {!!hasFeaturedCategories && (
        <div>
          <CategoryTitle strong>Featured</CategoryTitle>
          <Stack direction={screenLg ? 'column' : 'row'} spacing="xs">
            {featuredCategories.map((category, index) => {
              const { id, name, image_url } = category
              return (
                <MoreCategoryItem
                  key={id}
                  name={name ?? ''}
                  image={image_url ?? ''}
                  drawerIsVisible={drawerIsVisible}
                  onCategorySelect={() => onCategorySelect(category, 0, index)}
                />
              )
            })}
          </Stack>
        </div>
      )}
      <div>
        {!!hasFeaturedCategories && <CategoryTitle strong>Other Categories</CategoryTitle>}
        <OtherCategories>
          {moreCategories.map((category, index) => {
            const { id, name, image_url } = category
            return (
              <MoreCategoryItem
                key={id}
                image={image_url ?? ''}
                name={name ?? ''}
                drawerIsVisible={drawerIsVisible}
                onCategorySelect={() => onCategorySelect(category, undefined, undefined, index)}
              />
            )
          })}
        </OtherCategories>
      </div>
    </Stack>
  )
}

const CategoryTitle = styled(Body)`
  margin-left: 1rem;
  margin-right: 1rem;
`

const OtherCategories = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
`
